import { useMount } from 'ahooks';
import React, { useState } from 'react';
import Cookies from 'js-cookie';
import classNames from 'classnames';

const ProductCompareButton = (props) => {
  const [selection, setSelection] = useState([]);

  useMount(() => {
    let currentSelection = Cookies.get('compareProducts');
    if (currentSelection) {
      setSelection(JSON.parse(currentSelection));
    }
    window.theme_app.on('product-compare-update', (state) => {
      setSelection(state.compareProducts);
    });
  });

  const handleClick = () => {
    let newSelection = [];
    if (selection.includes(props.product)) {
      newSelection = selection.filter((item) => item !== props.product);
    } else {
      newSelection = [...selection, props.product];
    }
    window.theme_app.emit('product-compare-update', { compareProducts: [...new Set(newSelection)] });
    Cookies.set('compareProducts', JSON.stringify(newSelection));
  };

  let buttonClasses = classNames('product-compare-button', {
    'is-selected': selection.includes(props.product),
  });

  return (
    <button className={buttonClasses} onClick={handleClick}>
      Add to Compare
    </button>
  );
};

export default ProductCompareButton;
